/**
 * GraphQL Query
 * 商品画面
 */

/**
 * 商品一覧
 */
export const GRAPH_QL_QUERY_PRODUCT_LIST =
`
  query {
    products ( ? ) {
      edges {
        node {
          uuid
          code
          name
          nameKana
          brand{
            uuid
            code
          }
          category
          productCategory
          productDescription
          attributes {
            attrId
            attrValue
          }
        }
      }
      totalCount
    }
  }
`

/**
 * 商品詳細
 */
export const GRAPH_QL_QUERY_PRODUCT_DETAIL =
`
  query {
    product ( ? ) {
      uuid
      code
      name
      nameKana
      coreProductName
      productNameAbbreviation
      isActive
      productType
      productCategory
      brand {
        uuid
        code
      }
      subBrand {
        uuid
        code
      }
      makerProductCode
      productYear
      seasonCode
      mainCategoryCode
      category
      gender {
        code
        name
      }
      salesPeriodFrom
      salesPeriodTo
      isOnline
      onlineDatetime
      offlineDatetime
      colorGroupCode
      mainColorCode
      sizeGroupCode
      productDescription
      productDetail
      catchphrase
      mediaCoverage
      seoMeasurement
      appeal
      remarks
      tags
      isBuyableOnly
      isShipment
      isInventoryControl
      isSearchable
      isSearchableIfUnavailable
      isEditable
      isOrdered
      attributes {
        attrId
        attrValue
      }
      images {
        id
        no
        imageType
        displayOrder
        comment
        isActive
        attributes {
          attrId
          attrValue
        }
      }
      fkus ( isActive: 1 ) {
        uuid
        id
        isActive
        color {
          code
          name
        }
        skus ( isActive: 1 ) {
          uuid
          id
          code
          name
          skuNameKana
          skuNameAbbreviation
          isActive
          jan     
          displayOrder
          skuType     
          makerSku
          ean
          preparingShipmentStartedAt
          releaseDatetime
          minOrderQuantity
          maxOrderQuantity
          maxOrderableQuantityForUser
          suggestedRetailPriceExTax
          suggestedRetailPriceInTax
          costExTax
          priceExTax
          priceInTax
          salesPeriodFrom
          salesPeriodTo
          isOnline
          onlineDatetime
          offlineDatetime
          productDescription
          productDetail
          isBuyableOnly
          isShipment
          isInventoryControl
          isSearchable
          isSearchableIfUnavailable
          isOrdered
          color {
            code
            name
          }
          size {
            code
            name
          }
          plus {
            priceExTax
            priceInTax
            saleType
          }
          components {
            id
            uuid
            qty
            salesAmountExTax
            salesAmountInTax
            displayOrder
            attributes {
              attrId
              attrValue
            }
            product {
              name
              uuid
              code
            }
            sku {
              name
              uuid
              code
              priceInTax
              color {
                code
                name
              }
              size {
                code
                name
              }
            }
          }
          attributes {
            attrId
            attrValue
          } 
        }
        images {
          id
          no
          imageType
          displayOrder
          comment
          isActive
          attributes {
            attrId
            attrValue
          }
        }
      }
    }
  }
`

/**
 * 商品詳細最終更新日時
 */
export const GRAPH_QL_QUERY_PRODUCT_DATETIME =
`
  query {
    product( ? ) {
      updatedAt
    }
  }
`

/**
 * カスタマイズ属性マスタ
 */
export const GRAPH_QL_QUERY_CUSTOMIZE_MASTER =
`
  query {
    customizeProperties {
      functionKey
      attributeKey
      attributeName
      inputType
      isRequired
      description
      optionKey
      defaultValue
      displayOrder
      childCustomizeProperty {
        functionKey
        attributeKey
        attributeName
        inputType
        isRequired
        description
        optionKey
        defaultValue
        displayOrder
        childCustomizeProperty {
          functionKey
          attributeKey
          attributeName
          inputType
          isRequired
          description
          optionKey
          defaultValue
          displayOrder
          childCustomizeProperty {
            functionKey
            attributeKey
            attributeName
            inputType
            isRequired
            description
            optionKey
            defaultValue
            displayOrder
            childCustomizeProperty {
              functionKey
              attributeKey
              attributeName
              inputType
              isRequired
              description
              optionKey
              defaultValue
              displayOrder
              childCustomizeProperty {
                functionKey
                attributeKey
                attributeName
                inputType
                isRequired
                description
                optionKey
                defaultValue
                displayOrder
              }
            }
          }
        }
      }
    }
  }
`

/**
 * カラーマスタ
 */
export const GRAPH_QL_QUERY_COLOR_MASTER =
`
  query {
    colors {
      code
      name
    }
  }
`

/**
 * カラーグループマスタ
 */
export const GRAPH_QL_QUERY_COLOR_GROUP_MASTER =
`
  query {
    colorGroups {
      code
      name
      color {
        code
        name
      }
    }
  }
`

/**
 * サイズマスタ
 */
export const GRAPH_QL_QUERY_SIZE_MASTER =
`
  query {
    sizes {
      code
      name
    }
  }
`

/**
 * サイズグループマスタ
 */
export const GRAPH_QL_QUERY_SIZE_GROUP_MASTER =
`
  query {
    sizeGroups {
      code
      name
      size {
        code
        name
      }
    }
  }
`

/**
 * 性別マスタ
 */
export const GRAPH_QL_QUERY_GENDER_MASTER =
`
  query {
    genders {
      code
      name
    }
  }
`

/**
 * ブランドマスタ
 */
export const GRAPH_QL_QUERY_BRAND_MASTER =
`
  query {
    brands {
      uuid
      code
      name
      nameKana
    }
  }
`

/**
 * 構成品選択用品番一覧
 */
export const GRAPH_QL_QUERY_SEARCHER_PRODUCT_LIST =
`
query {
  products ( ?, isActive: 1 ) {
    edges {
      node {
        uuid
        code
        name
      }
    }
    totalCount
  }
}
`

/**
 * 構成品選択用SKU一覧
 */
export const GRAPH_QL_QUERY_SEARCHER_SKU_LIST =
`
query {
  skus ( ?, isActive: 1, limit: 1000 ) {
    edges {
      node {
        name
        uuid
        code
        priceInTax
        product {
          code
          brand {
            name
          }
          name
        }
        color {
          code
          name
        }
        size {
          code
          name
        }
      }
    }
    totalCount
  }
}
`

/**
 * コピー用SKU一覧
 */
export const GRAPH_QL_QUERY_SEARCHER_COPY_SKU_LIST =
`
query {
  skus ( ?, isActive: 1, limit: 1000 ) {
    edges {
      node {
        uuid
        id
        code
        name
        skuNameKana
        skuNameAbbreviation
        isActive
        jan     
        displayOrder
        skuType     
        makerSku
        ean
        preparingShipmentStartedAt
        releaseDatetime
        minOrderQuantity
        maxOrderQuantity
        maxOrderableQuantityForUser
        suggestedRetailPriceExTax
        suggestedRetailPriceInTax
        costExTax
        priceExTax
        priceInTax
        salesPeriodFrom
        salesPeriodTo
        isOnline
        onlineDatetime
        offlineDatetime
        productDescription
        productDetail
        isBuyableOnly
        isShipment
        isInventoryControl
        isSearchable
        isSearchableIfUnavailable
        isOrdered
        color {
          code
          name
        }
        size {
          code
          name
        }
        plus {
          priceExTax
          priceInTax
          saleType
        }
        components {
          id
          uuid
          qty
          salesAmountExTax
          salesAmountInTax
          displayOrder
          attributes {
            attrId
            attrValue
          }
          product {
            name
            uuid
            code
          }
          sku {
            name
            uuid
            code
            priceInTax
            color {
              code
              name
            }
            size {
              code
              name
            }
          }
        }
        attributes {
          attrId
          attrValue
        } 
      }
    }
  }
}
`

/**
 * 受注数確認画面一覧
 */
export const GRAPH_QL_QUERY_ORDER_QUANTITY_LIST =
`
query {
  orderQuantities ( ? ) {
    edges {
      node {
        stockType
        site { 
          code 
          name
          type
        }
        sku { 
          code
          name
          jan
          releaseDatetime
        }
        orderItem {
          orderedQty
          pendingQty
        }
        sendOrder {
          productId
          unallocatedQty
        }
        ecStockDistr { 
          amount 
          stockType
        }
        ecStock {
          stockType
          ordered
          exported
          qty
        }
        attributes {
          attrId
          attrValue
        }
      }
    }
    totalCount
  }
}
`
